
import { Loader2 } from "lucide-react"

interface AILoadingProps {
  compact?: boolean
}

export function AILoading({ compact = false }: AILoadingProps) {
  return (
    <div className={`p-6 flex flex-col items-center justify-center bg-gradient-to-br from-[#000808] to-[#0F1726] rounded-md shadow-md ${!compact ? 'mt-2' : ''}`}>
      <Loader2 className="h-8 w-8 text-[#FFC745] animate-spin mb-2" />
      <p className="text-sm text-[#FFC745] animate-pulse font-medium">Analyzing caregiver data...</p>
    </div>
  )
}
